var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.047,
    height: 18.309,
    viewBox: "0 0 15.047 18.309",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-share",
    "data-name": "Icon feather-share",
    transform: "translate(-5 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1771",
    "data-name": "Trac\\xE9 1771",
    d: "M6,18v6.524a1.631,1.631,0,0,0,1.631,1.631h9.785a1.631,1.631,0,0,0,1.631-1.631V18",
    transform: "translate(0 -6.846)",
    fill: "none",
    stroke: "#3e3e3e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1772",
    "data-name": "Trac\\xE9 1772",
    d: "M18.524,6.262,15.262,3,12,6.262",
    transform: "translate(-2.738)",
    fill: "none",
    stroke: "#3e3e3e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1773",
    "data-name": "Trac\\xE9 1773",
    d: "M18,3V13.6",
    transform: "translate(-5.476)",
    fill: "none",
    stroke: "#3e3e3e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/shareIcon.b4bf451cae752a787b20814a135da9d0.svg";
export { ForwardRef as ReactComponent };